<script setup>

import ModalBasic from "../modals/basicModal.vue";
import {computed, ref} from "vue";

const props = defineProps({
    expertContract: {
        type: Object,
        required: true
    }
})

const modalOpen = ref(false);
const sendPdfCopy = ref(false);

const openModal = () => {
    modalOpen.value = true
}

const deleteExpertContract = async () => {
    let res;
    try {
        if (sendPdfCopy.value === true) {
            res = await axios.delete(route('expert-contracts.sendCopyAndDelete', props.expertContract.id))
        } else {
            res = await axios.delete(route('expert-contracts.destroy', props.expertContract.id))
        }
    } catch (error) {
        console.error('Error deleting expert contract:', error)
    }

    if (res.data?.success) {
        window.location.href = route('expert-contracts.index');
    }
}

const signedRequestCount = computed(() => props.expertContract.signed_signature_request_count);

</script>
<template>
    <div>
        <slot name="trigger" :open="openModal">
            <button-danger @click="openModal">
                {{ _mft('expertContract:deleteContract') }}
            </button-danger>
        </slot>

        <modal-basic
            :open="modalOpen"
        >
            <template #body>
                <div>
                    <h5>
                        {{ _mft('expertContract:deleteContract.areYouSure') }}
                    </h5>
                    <p>
                        {{ _mft('expertContract:deleteContract.disclaimer') }}
                    </p>
                </div>
                <div
                    v-if="signedRequestCount > 0"
                >
                    <card-sub class="mb-4">
                        <p class="mb-0 text-center">
                            <i class="fa-regular fa-triangle-exclamation text-yellow-500 mr-1"></i>
                            {{ _mft('expertContract:deleteContract.signedBy', {count: signedRequestCount}) }}
                        </p>
                    </card-sub>

                    <toggle-switch
                        :label="_mft('expertContract:deleteContract.sendPdfCopy')"
                        v-model:content="sendPdfCopy"
                    />
                </div>
                <div class="mt-4 flex space-x-4 justify-end">
                    <button-secondary
                        @click="modalOpen = false"
                    >
                        {{ _mft('shared:action.cancel') }}
                    </button-secondary>
                    <button-danger
                        @click="deleteExpertContract"
                    >
                        {{ sendPdfCopy ? _mft('expertContract:sendCopyAndDelete') : _mft('shared:action.delete') }}
                    </button-danger>
                </div>
            </template>
        </modal-basic>
    </div>
</template>

